import type React from 'react';

import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

import StandardButton from 'components/buttons/StandardButton';
import TMXDialog from 'components/dialogs/TMXDialog';
import { BodyRegular, H3 } from 'components/typography/Typography';

export interface MakeDecisionProps {
  open?: boolean;
  loading?: boolean;
  onClose?: () => void;
  onConfirmDecision: () => void;
  onExited?: () => void;
  title: string;
  body: string;
  confirmText: string;
}

const MakeDecisionDialog: React.FC<React.PropsWithChildren<MakeDecisionProps>> = ({
  open,
  onClose,
  onConfirmDecision,
  onExited,
  title,
  body,
  confirmText,
}) => {
  const { t } = useTranslation();

  return (
    <TMXDialog fullWidth open={open} TransitionProps={{ onExited }}>
      <DialogTitle>
        <H3>{title}</H3>
      </DialogTitle>
      <DialogContent>
        <BodyRegular>{body}</BodyRegular>
      </DialogContent>
      <DialogActions>
        <StandardButton onClick={onClose}>{t('ccl')}</StandardButton>
        <StandardButton onClick={onConfirmDecision}>{confirmText}</StandardButton>
      </DialogActions>
    </TMXDialog>
  );
};

export default MakeDecisionDialog;
